"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));

var _core = require("@material-ui/core");

var _RadioButtonChecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonChecked"));

var _RadioButtonUnchecked = _interopRequireDefault(require("@material-ui/icons/RadioButtonUnchecked"));

var _ui = require("@probeton/ui");

var _solarReact = require("@solar/solar-react");

var _EditList = _interopRequireDefault(require("./EditList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {}
  };
});

var CertificationTicketList = function CertificationTicketList(_ref) {
  var tickets = _ref.tickets,
      unrequestedChanges = _ref.unrequestedChanges,
      onCreateTicket = _ref.onCreateTicket,
      onMergeTicket = _ref.onMergeTicket,
      openTicket = _ref.openTicket,
      openFabricate = _ref.openFabricate,
      setPdfOpen = _ref.setPdfOpen,
      labels = _ref.labels;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      dialogOpen = _useState2[0],
      setDialogOpen = _useState2[1];

  var editableTickets = tickets.filter(function (_ref2) {
    var status = _ref2.status;
    return status === 'created' || status === 'rejected';
  });

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      _selectedTicket = _useState4[0],
      _selectTicket = _useState4[1]; // first editableTicket is by default selected to be merged to


  var selectedTicket = _selectedTicket || (_selectedTicket === false ? null : editableTickets.length > 0 && editableTickets[0]._id);

  var selectTicket = function selectTicket(ticketId) {
    if (selectedTicket === ticketId) {
      return _selectTicket(false);
    }

    _selectTicket(ticketId);
  };

  if (!tickets && !unrequestedChanges || tickets.length + unrequestedChanges.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_solarReact.EmptyState, {
      Icon: _Edit["default"],
      label: labels.empty
    });
  }

  var onClickStart = function onClickStart() {
    if (editableTickets.length === 0) {
      onCreateTicket();
    } else {
      // show Dialog to select one of the editableTickets
      selectTicket(null);
      setDialogOpen(true);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, unrequestedChanges.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.recentChanges), /*#__PURE__*/_react["default"].createElement(_EditList["default"], {
    edits: unrequestedChanges,
    openFabricate: openFabricate,
    setPdfOpen: setPdfOpen,
    labels: labels.edits
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      maxWidth: 1024,
      padding: 8
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flexGrow: 2
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return onClickStart();
    },
    variant: "outlined",
    color: "primary"
  }, labels.createTicket))) : '', tickets.filter(function (_ref3) {
    var status = _ref3.status;
    return status !== 'published';
  }).length > 0 ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.currentTickets), /*#__PURE__*/_react["default"].createElement(_core.List, null, tickets.filter(function (_ref4) {
    var status = _ref4.status;
    return status !== 'published';
  }).map(function (_ref5) {
    var _id = _ref5._id,
        author = _ref5.author,
        status = _ref5.status,
        changes = _ref5.changes;
    return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
        src: author.person.avatar && author.person.avatar.src
      }),
      textLabel: status,
      text: "".concat(author.person.fullName, " - ").concat(labels.tickets(changes.length)),
      onClick: function onClick() {
        return openTicket(_id);
      }
    });
  }))) : '', tickets.filter(function (_ref6) {
    var status = _ref6.status;
    return status === 'published';
  }).length > 0 ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.publishedTickets), /*#__PURE__*/_react["default"].createElement(_core.List, null, tickets.filter(function (_ref7) {
    var status = _ref7.status;
    return status === 'published';
  }).map(function (_ref8) {
    var _id = _ref8._id,
        author = _ref8.author,
        status = _ref8.status,
        changes = _ref8.changes;
    return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
        src: author.person.avatar && author.person.avatar.src
      }),
      textLabel: status,
      text: "".concat(author.person.fullName, " - ").concat(labels.tickets(changes.length)),
      onClick: function onClick() {
        return openTicket(_id);
      }
    });
  }))) : '', /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    open: !!dialogOpen
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, labels.select.title), /*#__PURE__*/_react["default"].createElement(_core.DialogContent, null, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2"
  }, labels.select.message1), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2"
  }, labels.select.message2), /*#__PURE__*/_react["default"].createElement(_core.List, null, editableTickets.map(function (_ref9) {
    var _id = _ref9._id,
        author = _ref9.author,
        status = _ref9.status,
        changes = _ref9.changes;
    return /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
      icon: /*#__PURE__*/_react["default"].createElement(_core.IconButton, null, selectedTicket === _id ? /*#__PURE__*/_react["default"].createElement(_RadioButtonChecked["default"], null) : /*#__PURE__*/_react["default"].createElement(_RadioButtonUnchecked["default"], null)),
      textLabel: status,
      text: "".concat(author.person.fullName, " - ").concat(labels.tickets(changes.length)),
      onClick: function onClick() {
        return selectTicket(_id);
      }
    });
  }))), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return setDialogOpen(false);
    }
  }, labels.cancel), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      setDialogOpen(null);
      onMergeTicket(selectedTicket);
    },
    disabled: !selectedTicket,
    variant: "outlined",
    color: "primary"
  }, labels.select.merge), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      setDialogOpen(null);
      onCreateTicket();
    },
    disabled: !!selectedTicket,
    variant: "outlined",
    color: "primary"
  }, labels.select.newTicket))));
};

CertificationTicketList.propTypes = {
  className: _propTypes["default"].string,
  labels: _propTypes["default"].object.isRequired,
  tickets: _propTypes["default"].array,
  unrequestedChanges: _propTypes["default"].array
};
CertificationTicketList.defaultProps = {
  className: '',
  tickets: [],
  unrequestedChanges: []
};
var _default = CertificationTicketList;
exports["default"] = _default;